import { render, staticRenderFns } from "./Step5.vue?vue&type=template&id=563151b5&scoped=true&"
import script from "./Step5.vue?vue&type=script&lang=js&"
export * from "./Step5.vue?vue&type=script&lang=js&"
import style0 from "./Step5.vue?vue&type=style&index=0&id=563151b5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563151b5",
  null
  
)

export default component.exports